import * as React from "react";
import styled from "styled-components";
import { Navigate, Route, Routes } from "react-router-dom";
import { InternDesktopLayout, MbjLink, MbjSectionMenu } from "@mbj-front-monorepo/ui";
import { NotFound } from "../NotFound/NotFound";
import { MesRecherches } from "./MesRecherches/MesRecherches";
import {Dashboard} from "./Dashboard/Dashboard";
import {Recherche2} from "./Recherche/Recherche2";
import {Result} from "./Result/Result";
import {ProfilsRetenus2} from "./ProfilsRetenus/ProfilsRetenus2";

interface Recrutements2CtrlProps {}

function Recrutements2Ctrl(props: Recrutements2CtrlProps) {
  return (
    <div className="Recrutements2">
      <Routes>
        <Route
          element={
            <InternDesktopLayout
              type="Entreprise"
              mbjSectionMenu={
                <MbjSectionMenu>
                  <MbjLink to="dahboard">Tableau de bord</MbjLink>
                  <MbjLink to="recherche">Recherche</MbjLink>
                  <MbjLink to="profils-retenus">Profils retenus</MbjLink>
                </MbjSectionMenu>
              }
            />
          }
        >
          <Route path="" element={<Navigate to="dahboard" />} />
          <Route path="/dahboard" element={<Dashboard />} />
          <Route path="/resultats/:id" element={<Result />} />
          <Route path="/recherche" element={<Recherche2 />} />
          <Route path="/resume/:id" element={<MesRecherches />} />
          <Route path="/profils-retenus" element={<ProfilsRetenus2 />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </div>
  );
}
export const Recrutements2 = styled(Recrutements2Ctrl)((props) => ({}));
